import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

/** Shared active/inactive styles for page tabs hosted in the top navbar. */
export function navbarTabClass(active: boolean): string {
  return cn(
    "-mb-px shrink-0 border-b-[3px] px-2.5 py-1.5 text-sm font-semibold transition-colors sm:px-3",
    active
      ? "border-[#8b9aff] text-[#8b9aff]"
      : "border-transparent text-white hover:text-white/90",
  )
}

/** Horizontal scroll wrapper for navbar-hosted page tabs. */
export function NavbarTabList({ children }: { children: ReactNode }) {
  return (
    <div className="min-w-0 max-w-full overflow-x-auto overflow-y-hidden">
      <div className="flex min-w-max items-center gap-0.5 sm:gap-1">{children}</div>
    </div>
  )
}
